<template>
  <div id="editor" class="col-sm-12 nopads">
    <div class="col-sm-12 editor-form" >
        <h2 class="editor-header">{{ listUpdate.title }}</h2>
        <div class="col-sm-12 nopads" style="height: 20em">
              <!--Users-->
              <span class="span-title">
                {{ $t('notification_list.select_users') }}
              </span>
              <multiselect
                v-model="listUpdate.users"
                track-by="id"
                :multiple="true"
                :hide-selected="true"
                :deselect-label="$t('common.remove_selection')"
                :select-label="$t('common.select')"
                :placeholder="$t('notification_list.select_users')"
                :selected-label="$t('common.selected')"
                :custom-label="getName"
                :searchable="true"
                :max-height="200"
                :internal-search="false"
                :options="filteredUser"
                :loading="loading"
                :close-on-select="false"
                @search-change="searchList"
              >
                <template #noResult>
                  <span>{{ $t('common.not_found') }}</span>
                </template>
                <template #noOptions>
                  <span>{{ $t('common.no_results') }}</span>
                </template>
              </multiselect>
        </div>
        <div class="mt-1 col-sm-12 d-flex justify-content-end">
          <button
            class="btn btn-secondary form-button"
            @click.stop="$emit('close')"
          >
              {{ $t('common.cancel') }}
          </button>
          <button
            class="btn btn-success form-button"
            :disabled="loading"
            @click.stop="submitlist"
          >
              {{ $t('common.save') }}
          </button>
        </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {inject} from "vue";

export default {
    name: 'NotificationListEditor',
    mixins: [restApi],
    props: {
        list: {
            type: Object,
            default: null
        },
    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data: function () {
        return {
            loading: false,
            users: [],
            filteredUser: [],
            listUpdate: JSON.parse(JSON.stringify(this.list))
        }
    },
    mounted: function () {
        this.fetchUsers()
    },
    methods: {
        searchList(query) {
            this.filteredUser = this.users.filter(function (user) {
                return user.first_name.toLowerCase().startsWith(query.toLowerCase()) ||
                    user.last_name.toLowerCase().startsWith(query.toLowerCase())
            });
        },
        getName(customer) {
            return customer.first_name + ' ' + customer.last_name
        },
        fetchUsers: function () {
            this.loading = true
            this.restFetchParams(this.userCompanyUrl, {active: 1}, this.handleUsers)
        },
        handleUsers: function (response) {
            this.users = response.data
            this.filteredUser.push(...this.users)
            this.loading = false
        },
        getParams: function () {
            let users = []
            this.listUpdate.users.forEach(function (user) {
                users.push(user.id)
            })
            return {
                users: users,
                topic: this.listUpdate.topic
            }
        },
        submitlist: function () {
            let list = this.getParams()
            if (list) {
                this.loading = true
                this.restAdd(this.notificationSubsUrl, list, this.submitListSuccess, this.submitListFail)
            }
        },
        submitListSuccess: function () {
            this.$emit('closeAndUpdate')
            this.loading = false
        },
        submitListFail: function () {
            this.showAlert(this.$t('common.alert_update_failed'))
            this.loading = false
        }
    }
}
</script>
